import "emoji-picker-element";
import { useEffect, useRef } from "react";
import styled from "styled-components";

const EmojiPickerWrapper = ({ onEmojiSelect, onClose }) => {
  const wrapperRef = useRef();

  useEffect(() => {
    const picker = wrapperRef.current?.querySelector("emoji-picker");

    const handleEmojiClick = (e) => {
      if (onEmojiSelect) {
        onEmojiSelect(e.detail.unicode);
      }
    };

    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        if (onClose) onClose();
      }
    };

    if (picker) {
      picker.addEventListener("emoji-click", handleEmojiClick);
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      if (picker) {
        picker.removeEventListener("emoji-click", handleEmojiClick);
      }
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onEmojiSelect, onClose]);

  return (
    <EmojiWrapper ref={wrapperRef}>
      <emoji-picker></emoji-picker>
    </EmojiWrapper>
  );
};

const EmojiWrapper = styled.div`
  position: absolute;
  top: -400px;
  z-index: 100;

  @media (max-width: 768px) {
    position: fixed;
    top: unset;
    bottom: 500px;
    right: 5%;
    left: 5%;
  }
`;

export default EmojiPickerWrapper;
